import axios from "axios";
import { APIURL } from "../../../APIHandler/APIURL"
import { Headers } from "../../../APIHandler/HeaderAPI";
import { reloadHandler } from "../../../utlis/utlis";
import { Vouchers_failure, Vouchers_request, Vouchers_success } from "../../Reducer/Vouchers/VouchersSlice";

export const VoucherAPI = (payload) => async (dispatch, getState) => {
    dispatch(Vouchers_request())
    const eventItemId=localStorage.getItem("eventItemId")
    const auth_token = localStorage.getItem("auth_token")
  
    try {
        const { data } = await axios.get(`${APIURL.vouchers}/${eventItemId}`, {
            headers: {
                "host-url": Headers?.["host-url"],
                "language": Headers?.language,
             "event-slug":Headers?.["event-slug"],
                "Content-type": "application/json",
                Authorization: `Bearer ${auth_token}`
            },
        })
        dispatch(Vouchers_success(data))

    } catch (error) {
        reloadHandler(error?.response?.status)
        dispatch(Vouchers_failure(error?.response?.data))

    }
}